<template>
  <AtomsCalculatorFrame
    iframe-class="!mx-auto"
    :type="type"
    :src="src"
    scroll="yes"
  />
</template>

<script>
export default {
  name: 'MoleculesCalculatorBudgetPlanner',

  data: () => ({
    type: 'Budget_Planner',
    src: '//www.visionabacus.net/Tools/B3/SuiteA/A400/Budget_Planner/CompareClub'
  })
}
</script>
